import React, { useState } from "react";
import { Card } from "semantic-ui-react";
import OldAssetsSelectionCard from "../OldAssetsSelectionCard/OldAssetsSelectionCard";
import { useTranslation } from "react-i18next";

export const ApproverAssetSelectionCarousel = ({
  approver,
  assets,
  handleAssetChange,
  approverAssetMap,
}) => {
  const { t } = useTranslation("common");
  const checkIfIsSelectedForApprover = (item) => {
    if (approver && approver.id && approverAssetMap[approver.id] !== undefined) {
      return approverAssetMap[approver.id].selectedItems.map((asset) => asset.id).includes(item.id);
    }
    return false;
  };

  const mapped = assets.map((item) => {
    return { ...item, isSelected: checkIfIsSelectedForApprover(item) };
  });
  const [carouselItems, setCarouselItems] = useState(mapped);

  const handleSelect = (asset) => {
    const copy = [...carouselItems];
    const targetIndex = copy.findIndex((item) => item.id === asset.id);
    const selectedValue = copy[targetIndex].isSelected;
    copy[targetIndex].isSelected = !selectedValue;
    setCarouselItems(copy);

    const selectedItems = carouselItems.filter((item) => item.isSelected);
    handleAssetChange(approver, selectedItems);
  };

  return (
    <div className="asset-cards-container">
      <Card.Group itemsPerRow={6}>
        {carouselItems.map((asset, idx) => (
          <OldAssetsSelectionCard
            key={asset.id}
            t={t}
            asset={asset}
            handleSetClickedAssetId={() => handleSelect(asset)}
          />
        ))}
      </Card.Group>
    </div>
  );
};
